<template>
    <div>
        <hd-header></hd-header>
        <div style="padding-top: 130px;">
            <div style="text-align: center;">
                <img src="../../assets/images/progress/three.png" alt="">
            </div>
            <div
                style="display: flex;justify-content: center;align-items: center;margin-bottom: 60px;margin-top: 50px;">
                <el-card style="width: 1000px;">
                    <div slot="header" class="clearfix">
                        <span>教师信息填写</span>
                    </div>
                    <sub-teacher-info pre="/teacher-info" next="/join-school" out="/teacher-success"></sub-teacher-info>
                </el-card>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
    import HdHeader from '../public/Header.vue'
    import HdFooter from '../public/FooterLogined.vue'
    import SubTeacherInfo from '../public/sub/SubTeacherInfo.vue'

    export default {
        name: 'TeacherCert',
        components: {
            HdHeader,
            HdFooter,
            SubTeacherInfo
        },
        data: function() {
            return {};
        },
        methods: {}
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/teacher/TeacherCert.vue